<template>
  <div>
    <div v-if="isWechatOrAlipay || debugMode" class="home">
      <div class="header">
        <div class="title">网红PK</div>
        <div class="rank">
          <div class="item">
            <div class="number">NO.2</div>
            <div class="name">张大仙</div>
            <div class="score">积分：95218</div>
            <div class="frame"></div>
            <div class="avatar">
              <img src="../assets/image/up20220702145435wpiM.jpg" alt="">
            </div>
          </div>
          <div class="item">
            <div class="number">NO.1</div>
            <div class="name">陈翔六点半</div>
            <div class="score">积分：113528</div>
            <div class="frame"></div>
            <div class="avatar">
              <img src="../assets/image/up202207021309099eU5.jpg" alt="">
            </div>
          </div>
          <div class="item">
            <div class="number">NO.3</div>
            <div class="name">聂小雨</div>
            <div class="score">积分：77541</div>
            <div class="frame"></div>
            <div class="avatar">
              <img src="../assets/image/up20220702203446eioB.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="title">主播列表</div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            @click="goAbout(item)"
          >
            <div class="image">
              <img :src="item.img" alt="">
            </div>
            <div class="info">
              <div class="name">{{ item.name }}</div>
              <div class="introduce">{{ item.introduce }}</div>
            </div>
            <div class="score">
              <div class="text">{{ item.score }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="error-container">
      <div class="error-icon">⚠️</div>
      <div class="error-text">请使用微信或支付宝扫码访问本页面。</div>
    </div>
    <div
      class="van-toast van-toast--middle van-toast--text van-toast--html"
      style="z-index: 2001; display: none; min-height: 0; min-width: 96px; padding: 8px 12px; width: -webkit-fit-content; width: fit-content;"
    >
      <div class="van-toast__text">正在自动登录直播</div>
    </div>
  </div>
</template>

<script>
import data from "../assets/json/data.json";
export default {
  data() {
    return {
      list: [],
      isWechatOrAlipay: false,
      debugMode: false
    };
  },
  mounted() {
    this.checkBrowser();
    this.getList();
  },
  methods: {
    goAbout(item) {
      localStorage.setItem("item", JSON.stringify(item));
      this.$router.push({ path: "/about" });
    },
    getList() {
      document.querySelector(".van-toast").style.display = "block";
      setTimeout(() => {
        document.querySelector(".van-toast").style.display = "none";
        if (localStorage.getItem("Images")) {
          this.list = JSON.parse(localStorage.getItem("Images"));
          return;
        }
        data.list.forEach((item) => {
          item.img = require("../assets/image/" + item.img);
        });
        localStorage.setItem("Images", JSON.stringify(data.list));
        this.list = data.list;
      }, 1000);
    },
    checkBrowser() {
      if (this.debugMode) return;
      const ua = navigator.userAgent.toLowerCase();
      this.isWechatOrAlipay = /micromessenger|alipayclient/i.test(ua);
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  background: url(../assets/image/home_header_bg.3b08283a.png) no-repeat;
  background-size: 100% auto;
  height: 100%;
  overflow-y: auto;
}

.van-toast--html .van-toast__text,
.van-toast--text .van-toast__text {
  margin-top: 0;
}

.van-toast {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  -webkit-align-items: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  box-sizing: content-box;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  font-size: 14px;
  -webkit-justify-content: center;
  justify-content: center;
  left: 50%;
  line-height: 20px;
  max-width: 70%;
  min-height: 88px;
  padding: 16px;
  position: fixed;
  text-align: center;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  white-space: pre-wrap;
  width: 88px;
  word-break: break-all;
}

.home .header {
  content: "viewport-units-buggyfill; height: 60.8vw";
  height: 60.8vw;
}

.home .header .title {
  color: #fff;
  content: "viewport-units-buggyfill; height: 4.133vw; padding-top: 8.667vw; line-height: 4vw; font-size: 4.267vw";
  font-size: 4.267vw;
  font-weight: 700;
  height: 4.133vw;
  line-height: 4vw;
  padding-top: 8.667vw;
  text-align: center;
}

.home .header .rank {
  content: "viewport-units-buggyfill; padding: 0 4.8vw";
  padding: 0 4.8vw;
}

.home .header .rank,
.home .header .rank .item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.home .header .rank .item {
  -webkit-box-flex: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  content: "viewport-units-buggyfill; height: 48vw";
  -ms-flex: 1;
  flex: 1;
  -ms-flex-flow: column;
  flex-flow: column;
  height: 48vw;
  justify-content: flex-end;
  position: relative;
}

.home .header .rank .item .number {
  color: #fff;
  content: "viewport-units-buggyfill; height: 4.933vw; line-height: 6vw; font-size: 6.533vw";
  font-size: 6.533vw;
  font-weight: 700;
  height: 4.933vw;
  line-height: 6vw;
  opacity: 0.25;
}

.home .header .rank .item .name {
  content: "viewport-units-buggyfill; font-size: 3.733vw";
  font-size: 3.733vw;
}

.home .header .rank .item .name,
.home .header .rank .item .score {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: #fff;
  display: -webkit-box;
  font-weight: 700;
  overflow: hidden;
  word-break: break-all;
}

.home .header .rank .item .score {
  content: "viewport-units-buggyfill; margin-bottom: 1.333vw; font-size: 3.467vw";
  font-size: 3.467vw;
  margin-bottom: 1.333vw;
}

.home .header .rank .item .frame {
  background-size: 100% 100%;
  bottom: 11.467vw;
  content: "viewport-units-buggyfill; bottom: 11.467vw";
}

.home .header .rank .item .avatar,
.home .header .rank .item .frame {
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 1;
}

.home .header .rank .item .avatar {
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.home .header .rank .item:first-child .number {
  content: "viewport-units-buggyfill; margin-bottom: 20.933vw";
  margin-bottom: 20.933vw;
}

.home .header .rank .item:first-child .frame {
  background-image: url(../assets/image/rank_2.1b53b9e6.png);
  content: "viewport-units-buggyfill; width: 16.667vw; height: 21.2vw";
  height: 21.2vw;
  width: 16.667vw;
}

.home .header .rank .item:first-child .avatar {
  bottom: 12.133vw;
  content: "viewport-units-buggyfill; width: 14.267vw; height: 14.267vw; bottom: 12.133vw";
  height: 14.267vw;
  width: 14.267vw;
}

.home .header .rank .item:nth-child(2) .number {
  content: "viewport-units-buggyfill; margin-bottom: 29.333vw";
  margin-bottom: 29.333vw;
}

.home .header .rank .item:nth-child(2) .frame {
  background-image: url(../assets/image/rank_1.14956bf9.png);
  content: "viewport-units-buggyfill; width: 22.533vw; height: 30vw";
  height: 30vw;
  width: 22.533vw;
}

.home .header .rank .item:nth-child(2) .avatar {
  bottom: 12.533vw;
  content: "viewport-units-buggyfill; width: 20vw; height: 20vw; bottom: 12.533vw";
  height: 20vw;
  width: 20vw;
}

.home .header .rank .item:nth-child(3) .number {
  content: "viewport-units-buggyfill; margin-bottom: 20.933vw";
  margin-bottom: 20.933vw;
}

.home .header .rank .item:nth-child(3) .frame {
  background-image: url(../assets/image/rank_3.d47896b0.png);
  content: "viewport-units-buggyfill; width: 16.667vw; height: 21.2vw";
  height: 21.2vw;
  width: 16.667vw;
}

.home .header .rank .item:nth-child(3) .avatar {
  bottom: 12.267vw;
  content: "viewport-units-buggyfill; width: 14.267vw; height: 14.267vw; bottom: 12.267vw";
  height: 14.267vw;
  width: 14.267vw;
}

.home .container {
  background: #fff;
  border-radius: 5.333vw 5.333vw 0 0;
  content: "viewport-units-buggyfill; border-radius: 5.333vw 5.333vw 0 0";
}

.home .container .title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ba6fe6;
  content: "viewport-units-buggyfill; height: 8.267vw; padding-left: 7.2vw; padding-right: 4.8vw; font-size: 3.2vw";
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.2vw;
  font-weight: 700;
  height: 8.267vw;
  line-height: 1;
  padding-left: 7.2vw;
  padding-right: 4.8vw;
  position: relative;
}

.home .container .title:before {
  background: #ba6fe6;
  border-radius: 0.533vw;
  content: "";
  height: 2.933vw;
  left: 4.8vw;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 1.067vw;
  z-index: 1;
}

.home .container .list {
  content: "viewport-units-buggyfill; padding: 0 4.8vw";
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: wrap;
  flex-flow: wrap;
  padding: 0 4.8vw;
}

.home .container .list .item {
  background: #fff;
  border-radius: 1.6vw;
  -webkit-box-shadow: 0 0.533vw 1.333vw 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 0.533vw 1.333vw 0 rgba(0, 0, 0, 0.25);
  content: "viewport-units-buggyfill; width: 40vw; height: 44vw; margin-bottom: 4vw; border-radius: 1.6vw; -webkit-box-shadow: 0px 0.533vw 1.333vw 0px rgba(0, 0, 0, .25); box-shadow: 0px 0.533vw 1.333vw 0px rgba(0, 0, 0, .25)";
  height: 44vw;
  margin-bottom: 4vw;
  overflow: hidden;
  width: 40vw;
}

.home .container .list .item:nth-child(odd) {
  content: "viewport-units-buggyfill; margin-right: 9.333vw";
  margin-right: 9.333vw;
}

.home .container .list .item .image {
  background: #ba6fe6;
  content: "viewport-units-buggyfill; width: 40vw; height: 33.333vw";
  display: block;
  height: 33.333vw;
  width: 40vw;
  img {
    width: 100%;
    height: 100%;
  }
}

.home .container .list .item .info {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  content: "viewport-units-buggyfill; height: 5.333vw; padding: 0 1.333vw";
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 5.333vw;
  padding: 0 1.333vw;
}

.home .container .list .item .info .name {
  -webkit-box-flex: 1;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: #333;
  content: "viewport-units-buggyfill; font-size: 3.2vw";
  display: -webkit-box;
  -ms-flex: 1;
  flex: 1;
  font-size: 3.2vw;
  font-weight: 700;
  overflow: hidden;
  word-break: break-all;
}

.home .container .list .item .info .introduce {
  border: 1px solid #ba6fe6;
  border-radius: 0.8vw;
  color: #ba6fe6;
  content: "viewport-units-buggyfill; height: 4.267vw; padding: 0 0.667vw; font-size: 2.667vw; border-radius: 0.8vw";
  font-size: 2.667vw;
  font-weight: 500;
  height: 4.267vw;
  padding: 0 0.667vw;
}

.home .container .list .item .info .introduce,
.home .container .list .item .score {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.home .container .list .item .score {
  content: "viewport-units-buggyfill; height: 5.333vw; padding: 0 1.333vw";
  height: 5.333vw;
  padding: 0 1.333vw;
}

.home .container .list .item .score .text {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: #333;
  content: "viewport-units-buggyfill; font-size: 3.2vw";
  display: -webkit-box;
  font-size: 3.2vw;
  font-weight: 500;
  overflow: hidden;
  word-break: break-all;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f4f4f4;
}

.error-icon {
  font-size: 64px;
  color: #ff6b6b;
  margin-bottom: 20px;
}

.error-text {
  font-size: 24px;
  color: #333;
  text-align: center;
}
</style>